import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 15 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="animate-slide-down bg-gradient-to-r from-[#1a4a2a] via-[#2a5a3a] to-[#1a4a2a] text-white py-3 px-4 text-center sticky top-0 z-50 shadow-lg border-b border-[#3a7a4a]/50" data-id="element-360">
      <div className="inline-flex items-center gap-3 md:gap-4" data-id="element-361">
        <span className="animate-pulse text-lg" data-id="element-362">⚡</span>
        <span className="text-white/80 text-sm md:text-base tracking-[0.15em] uppercase font-semibold" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-363">
          Oferta expira en
        </span>
        <span className="bg-[#ff4444] text-white px-3.5 py-1 rounded-lg text-lg md:text-xl tracking-widest leading-tight font-bold shadow-[0_0_15px_rgba(255,68,68,0.4)]" style={{
        fontFamily: "'Bebas Neue', sans-serif",
        letterSpacing: '0.18em'
      }} data-id="element-364">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
        <span className="text-white/30 text-xs hidden sm:inline" data-id="element-365">·</span>
        <span className="text-[#f0c040] text-sm md:text-base tracking-[0.12em] uppercase font-bold hidden sm:inline" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-366">
          🔥 Cupos limitados
        </span>
      </div>
    </div>;
}